import { Component, Input } from '@angular/core';

@Component({
  selector: 'bepatient-progress-icon',
  templateUrl: './progress-icon.component.html',
  styleUrls: ['./progress-icon.component.scss'],
  standalone: false
})
export class ProgressIconComponent {
  @Input() color: string; // Dynamic color for SVG
  @Input() progress: number; // Progress for ngIf statment
}
